import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { useState } from "react"
import type { ILesson } from "types/lessonTypes"
import { DeleteLessonDialog } from "./DeleteLessonDialog"
import { UpdateLessonDialog } from "./UpdateLessonDialog"

type Props = {
  lesson: ILesson
}

export function LessonCardMenu({ lesson }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <UpdateLessonDialog lesson={lesson} />
        <DeleteLessonDialog lesson={lesson} />
      </Menu>
    </>
  )
}
